module.exports = __webpack_public_path__ + "img/medical_expert.73cc306b.svg";